export function getHelpCenterLink({
  key = 'home',
  config,
  locale = 'EN',
  companyName = 'shore',
}: {
  key: string;
  locale: string;
  companyName: string;
  config: Record<string, Record<string, string>>;
}) {
  switch (companyName) {
    case 'shore':
      return (
        config?.helpcenter?.[key]?.replace(
          '__locale__',
          locale.toLowerCase()
        ) ?? ''
      );
    case 'localsearch':
      return 'https://cc.localsearch.ch/s/help?language=de&topic=Product_related_questions_NV&subtopic=MyCOCKPIT_booking_system_NV';
    default:
      return null;
  }
}

export const isTrialPhasePromoActive = ({
  companyName,
  trialDaysLeft,
  roles,
}: {
  companyName: string;
  trialDaysLeft: number;
  roles: string[];
}) =>
  companyName === 'shore' &&
  trialDaysLeft !== 0 &&
  (roles.includes('admin') || roles.includes('owner'));

export const isUpsellShorePOSActive = ({
  locale,
  companyName,
  packageCodes,
}: {
  locale: string;
  companyName: string;
  packageCodes: string[];
}) => {
  if (companyName !== 'shore') {
    return false;
  }

  const availableLocales = ['en', 'de', 'de-CH', 'es'];

  if (availableLocales.indexOf(locale) === -1) {
    return false;
  }

  if (
    packageCodes.includes('shore_basic') ||
    packageCodes.includes('shore_plus')
  ) {
    return true;
  }

  if (packageCodes.length === 0) {
    return true;
  }

  return false;
};
